module.exports = __webpack_public_path__ + "img/goquiry.ae10e6ed.png";